export function formatDate(data: string) {
    if (!data) return

    const split = data.split('-')
    const day = split[2];
    const month = split[1];
    const year = split[0];

    const formattedDate = `${day}/${month}/${year}`;
    return formattedDate
}

export function formatDateTime(data: string) {
    if (!data) return

    const split1 = data.split(' ')

    const splitDate = split1[0].split('-')
    const day = splitDate[2]
    const month = splitDate[1]
    const year = splitDate[0]

    const splitHour = split1[1].split(':')
    const hour = splitHour[0]
    const minute = splitHour[1]

    const formattedDate = `${day}/${month}/${year} ${hour}:${minute}`
    return formattedDate
}